var map = {
	"./404.svg": "a14a",
	"./bug.svg": "1779",
	"./chart.svg": "c829",
	"./clipboard.svg": "bc35",
	"./collapse.svg": "37cc",
	"./component.svg": "56d6",
	"./dashboard.svg": "f782",
	"./documentation.svg": "90fb",
	"./drag.svg": "9bbf",
	"./edit.svg": "aa46",
	"./education.svg": "ad1c",
	"./email.svg": "cbb7",
	"./example.svg": "30c3",
	"./excel.svg": "6599",
	"./exit-fullscreen.svg": "dbc7",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./fixed-right-buy.svg": "1262",
	"./fixed-right-chat.svg": "ff34",
	"./fixed-right-code.svg": "f2fa",
	"./fixed-right-doc.svg": "cdb5",
	"./fixed-right-qq.svg": "4749",
	"./form.svg": "eb1b",
	"./fullscreen-exit.svg": "894b",
	"./fullscreen.svg": "9921",
	"./guide.svg": "6683",
	"./icon.svg": "9d91",
	"./image-load-fail.svg": "cba8",
	"./international.svg": "17df",
	"./language.svg": "2580",
	"./link.svg": "18f0",
	"./list.svg": "3289",
	"./lock.svg": "ab00",
	"./message.svg": "47ff",
	"./money.svg": "3046",
	"./nested.svg": "dcf8",
	"./password.svg": "2a3d",
	"./pdf.svg": "f9a1",
	"./people.svg": "d056",
	"./peoples.svg": "2f11",
	"./pro.svg": "66d9",
	"./qq.svg": "1430",
	"./reload.svg": "217a",
	"./search.svg": "8e8d",
	"./shopping.svg": "12a5",
	"./sidebar-breadcrumb.svg": "150a",
	"./sidebar-component.svg": "f210",
	"./sidebar-default.svg": "3452",
	"./sidebar-external-link.svg": "17a7",
	"./sidebar-keep-alive.svg": "8233",
	"./sidebar-layout.svg": "5660",
	"./sidebar-menu.svg": "e2fa",
	"./sidebar-mock.svg": "9fba",
	"./sidebar-other.svg": "149c",
	"./sidebar-permission.svg": "511e",
	"./sidebar-videos.svg": "20f8",
	"./size.svg": "8644",
	"./skill.svg": "096e",
	"./star.svg": "708a",
	"./tab.svg": "8fb7",
	"./table.svg": "47f1",
	"./theme.svg": "e534",
	"./tree-table.svg": "e7c8",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./wechat.svg": "80da",
	"./zip.svg": "8aa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";